import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { 
  FaUser, FaEnvelope, FaLock, FaPaperPlane, 
  FaCircleNotch 
} from 'react-icons/fa';
import './SignUp.css';

const RegisterForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    password: '',
    confirmPassword: '',
    role: 'Tenant'
  });

  const [status, setStatus] = useState({ message: '', type: '' });
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;

    // Map custom field names
    if (name === "user_name_field") {
      setFormData(prev => ({ ...prev, name: value }));
    } else if (name === "user_email_field") {
      setFormData(prev => ({ ...prev, email: value }));
    } else if (name === "user_password_field") {
      setFormData(prev => ({ ...prev, password: value }));
    } else if (name === "user_confirm_password_field") {
      setFormData(prev => ({ ...prev, confirmPassword: value }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setStatus({ message: '', type: '' });

    if (formData.password !== formData.confirmPassword) {
      setStatus({ message: 'Passwords do not match.', type: 'error' });
      setIsLoading(false);
      return;
    }

    try {
      const response = await fetch('https://ikazethouse-backend-32.onrender.com/api/v1/auth/signup', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          name: formData.name,
          email: formData.email,
          password: formData.password,
          role: formData.role
        }),
      });

      const data = await response.json();

      if (data.success) {
        setStatus({ message: 'Account created! Redirecting to login...', type: 'success' });
        setTimeout(() => navigate('/Login'), 2000);
      } else {
        setStatus({ message: data.message || 'Registration failed.', type: 'error' });
      }
    } catch (error) {
      setStatus({ message: 'Network error. Please try again.', type: 'error' });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="auth-page-container">
      
      {/* Visual Side */}
      <div className="auth-visual register-bg">
        <div className="visual-overlay">
          <div className="visual-content">
            <span className="badge-premium">Join GKM Invest</span>
            <h2>Your Journey to <br/> Better Living Starts Here.</h2>
            <p>Access the most exclusive property management dashboard in the region.</p>
          </div>
        </div>
      </div>

      {/* Form Side */}
      <div className="auth-form-side">
        <div className="form-wrapper">
          <div className="brand-logo">GKM INVEST</div>
          
          <div className="form-header">
            <h1>Create Account</h1>
            <p>Please provide your details to get started.</p>
          </div>

          {/* 🚫 Disable autofill */}
          <form onSubmit={handleSubmit} autoComplete="off">

            {/* 🔥 Hidden fake inputs */}
            <input type="text" name="fakeuser" style={{ display: "none" }} />
            <input type="password" name="fakepass" style={{ display: "none" }} />

            <div className="input-field">
              <label>Full Name</label>
              <div className="input-wrapper">
                <FaUser className="field-icon" />
                <input 
                  type="text" 
                  name="user_name_field"
                  placeholder="Your names" 
                  required 
                  onChange={handleChange}
                  value={formData.name}
                  autoComplete="off"
                />
              </div>
            </div>

            <div className="input-field">
              <label>Email Address</label>
              <div className="input-wrapper">
                <FaEnvelope className="field-icon" />
                <input 
                  type="email" 
                  name="user_email_field"
                  placeholder="name@example.com" 
                  required 
                  onChange={handleChange}
                  value={formData.email}
                  autoComplete="off"
                />
              </div>
            </div>

            <div className="input-grid">
              <div className="input-field">
                <label>Password</label>
                <div className="input-wrapper">
                  <FaLock className="field-icon" />
                  <input 
                    type="password" 
                    name="user_password_field"
                    placeholder="••••••••" 
                    required 
                    onChange={handleChange}
                    value={formData.password}
                    autoComplete="new-password"
                  />
                </div>
              </div>

              <div className="input-field">
                <label>Confirm</label>
                <div className="input-wrapper">
                  <FaLock className="field-icon" />
                  <input 
                    type="password" 
                    name="user_confirm_password_field"
                    placeholder="••••••••" 
                    required 
                    onChange={handleChange}
                    value={formData.confirmPassword}
                    autoComplete="new-password"
                  />
                </div>
              </div>
            </div>

            <button className="submit-btn" type="submit" disabled={isLoading}>
              {isLoading ? <FaCircleNotch className="spin" /> : <>Register Now <FaPaperPlane /></>}
            </button>
          </form>

          <p className="signup-prompt">
            Already have an account? <Link to="/Login">Sign In</Link>
          </p>

          {status.message && (
            <div className={`notification-toast ${status.type}`}>
              {status.message}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default RegisterForm;